import React from 'react';

import { AppShell, Container } from '@mantine/core';

import Header from './Header';

interface ShellProps {
  children: React.ReactNode;
}

export const Shell: React.FC<ShellProps> = ({ children }) => {
  return (
    <AppShell header={{ height: 60 }}>
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Main>
        <Container py="2rem" size="xl">
          {children}
        </Container>
      </AppShell.Main>
    </AppShell>
  );
};

export default Shell;
